var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { rootCss, TextButtonContent } from './TextButton';
var Root = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n"], ["\n  ", "\n  text-decoration: none;\n"])), rootCss);
/**
 * Link (<a />) version of TextButton.
 */
var TextButtonLink = React.forwardRef(function (_a, ref) {
    var children = _a.children, cssVarOverrides = _a.cssVarOverrides, _b = _a.disableTextSelect, disableTextSelect = _b === void 0 ? false : _b, _c = _a.fontFamily, fontFamily = _c === void 0 ? 'default' : _c, icon = _a.icon, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, _e = _a.size, size = _e === void 0 ? 'small' : _e, _f = _a.variant, variant = _f === void 0 ? 'blue' : _f, _g = _a.wrap, wrap = _g === void 0 ? true : _g, rest = __rest(_a, ["children", "cssVarOverrides", "disableTextSelect", "fontFamily", "icon", "iconPosition", "size", "variant", "wrap"]);
    return (React.createElement(Root, __assign({ "$cssVarOverrides": cssVarOverrides, "$disableTextSelect": disableTextSelect, "$fontFamily": fontFamily, "$size": size, "$variant": variant, "$wrapText": wrap }, rest, { ref: ref }),
        React.createElement(TextButtonContent, { icon: icon, iconPosition: iconPosition }, children)));
});
TextButtonLink.displayName = 'TextButtonLink';
export default TextButtonLink;
var templateObject_1;
//# sourceMappingURL=TextButtonLink.js.map